import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    DataSelect,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffShopServiceTokensNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formShopId, setFormShopId] = useState(null);
    const [formShopIdOptions, setFormShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-shop-service-tokens-new/select-data/shop-id').then(
            (response) => {
                setFormShopIdOptions(response.data);
            }
        );
    }, []);
    const [formTitle, setFormTitle] = useState(null);
    const [formIpAddress, setFormIpAddress] = useState(null);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleSave = async () => {
        await postData('/api/panel/page/taroff-shop-service-tokens-new/save-data', {
            shop_id: formShopId,
            title: formTitle,
            ip_address: formIpAddress,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد توکن</Title>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'شناسه فروشگاه'}
                            options={formShopIdOptions}
                            value={formShopId}
                            onChange={setFormShopId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'آی پی'}
                            value={formIpAddress}
                            onChange={setFormIpAddress}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleSave}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
